import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=3df855b5&scoped=true&"
import script from "./AddInfo.vue?vue&type=script&lang=js&"
export * from "./AddInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddInfo.vue?vue&type=style&index=0&id=3df855b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df855b5",
  null
  
)

export default component.exports